// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.selected {
  --background: var(--ion-color-light);
}

.scrollable-div {
  max-height: 75%;
  overflow-y: auto;
}

.sub-menu-list {
  padding: 0;
  margin: 0;
}

.menu-item {
  border-left: 5px solid var(--ion-color-primary);
  position: relative;
}
.menu-item .menu-icon {
  color: var(--ion-color-primary) !important;
}
.menu-item .menu-label {
  color: var(--ion-color-primary) !important;
  font-weight: bold !important;
}

.menu-chevron {
  color: var(--ion-color-primary) !important;
  transition: transform 0.3s ease;
  transform: rotate(-90deg);
}
.menu-chevron.expanded {
  transform: rotate(0deg);
}

ion-item-divider {
  background-color: color-mix(in srgb, var(--ion-color-primary) 8%, transparent);
}
ion-item-divider ion-label {
  color: var(--ion-color-primary) !important;
  font-weight: 600 !important;
}

.sub-menu-item {
  --padding-start: 12px;
  border-left: 5px solid var(--ion-color-primary);
  border-radius: 8px;
  color: black !important;
  margin: 4px 10px 4px 10px;
}
.sub-menu-item .menu-chevron {
  display: none !important;
}

.status-icon {
  height: var(--icon-size-xx-small);
  width: var(--icon-size-xx-small);
}

.battery-item {
  --min-height: 60px;
  --max-height: 60px;
}

.battery-content {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 10px;
}

.battery-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.battery-sn {
  font-weight: 500;
  color: black;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.battery-last-seen {
  font-size: 0.75rem;
  font-style: italic;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
}

.battery-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 800px) or (max-height: 550px) {
  ion-item.menu-item {
    --min-height: 40px;
    --max-height: 40px;
  }
  ion-item.menu-item .menu-label {
    font-size: var(--font-size-small) !important;
    font-weight: bold;
  }
  ion-item.menu-item .menu-icon {
    height: var(--icon-size-small);
    width: var(--icon-size-small);
  }
  ion-item.sub-menu-item {
    --min-height: 35px;
    --max-height: 35px;
    font-size: var(--font-size-small) !important;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 800px) and (min-height: 550px) {
  ion-item.menu-item {
    --min-height: 50px;
    --max-height: 50px;
  }
  ion-item.menu-item .menu-label {
    font-size: var(--font-size-small) !important;
    font-weight: bold;
  }
  ion-item.menu-item .menu-icon {
    height: var(--icon-size-small);
    width: var(--icon-size-small);
  }
  ion-item.sub-menu-item {
    --min-height: 45px;
    --max-height: 45px;
    font-size: var(--font-size-small) !important;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1000px) and (min-height: 600px) {
  ion-item.menu-item {
    --min-height: 55px;
    --max-height: 55px;
  }
  ion-item.menu-item .menu-label {
    font-size: var(--font-size-small) !important;
    font-weight: bold;
  }
  ion-item.menu-item .menu-icon {
    height: var(--icon-size-small);
    width: var(--icon-size-small);
  }
  ion-item.sub-menu-item {
    --min-height: 50px;
    --max-height: 50px;
    font-size: var(--font-size-small) !important;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/pages/logbooks/components/logbooks-menu/logbooks-menu.component.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;AACJ;;AAEA;EACE,UAAA;EACA,SAAA;AACF;;AAGA;EACI,+CAAA;EACA,kBAAA;AAAJ;AAEI;EACI,0CAAA;AAAR;AAGI;EACI,0CAAA;EACA,4BAAA;AADR;;AAKA;EACI,0CAAA;EACA,+BAAA;EACA,yBAAA;AAFJ;AAII;EACI,uBAAA;AAFR;;AAOA;EACI,8EAAA;AAJJ;AAMI;EACI,0CAAA;EACA,2BAAA;AAJR;;AASA;EACI,qBAAA;EACA,+CAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;AANJ;AAQI;EACI,wBAAA;AANR;;AAUA;EACE,iCAAA;EACA,gCAAA;AAPF;;AAWA;EACI,kBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;AARJ;;AAWA;EACI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AARJ;;AAWA;EACI,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AARJ;;AAWA;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AARJ;;AAWA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AARJ;;AAWA,sEAAA;AAEA,wBAAA;AAEE,2DAAA;AACA;EAEE;IACI,kBAAA;IACA,kBAAA;EAXN;EAaM;IACI,4CAAA;IACA,iBAAA;EAXV;EAcM;IACI,8BAAA;IACA,6BAAA;EAZV;EAgBE;IACI,kBAAA;IACA,kBAAA;IACA,4CAAA;EAdN;AACF;AAiBA,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACA;EAEE;IACE,kBAAA;IACA,kBAAA;EAlBJ;EAoBI;IACI,4CAAA;IACA,iBAAA;EAlBR;EAqBI;IACI,8BAAA;IACA,6BAAA;EAnBR;EAuBE;IACI,kBAAA;IACA,kBAAA;IACA,4CAAA;EArBN;AACF;AAyBA,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AACA;EAEE;IACE,kBAAA;IACA,kBAAA;EA1BJ;EA4BI;IACI,4CAAA;IACA,iBAAA;EA1BR;EA6BI;IACI,8BAAA;IACA,6BAAA;EA3BR;EA+BE;IACI,kBAAA;IACA,kBAAA;IACA,4CAAA;EA7BN;AACF;AAiCA,4BAAA","sourcesContent":["ion-item.selected {\r\n    --background: var(--ion-color-light);\r\n}\r\n\r\n.scrollable-div {\r\n    max-height: 75%;\r\n    overflow-y: auto;\r\n}\r\n\r\n.sub-menu-list {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n// Menu items (Pilot, Drone, Batteries sections)\r\n.menu-item {\r\n    border-left: 5px solid var(--ion-color-primary);\r\n    position: relative;\r\n\r\n    .menu-icon {\r\n        color: var(--ion-color-primary) !important;\r\n    }\r\n\r\n    .menu-label {\r\n        color: var(--ion-color-primary) !important;\r\n        font-weight: bold !important;\r\n    }\r\n}\r\n\r\n.menu-chevron {\r\n    color: var(--ion-color-primary) !important;\r\n    transition: transform 0.3s ease;\r\n    transform: rotate(-90deg);\r\n\r\n    &.expanded {\r\n        transform: rotate(0deg);\r\n    }\r\n}\r\n\r\n// Organization dividers\r\nion-item-divider {\r\n    background-color: color-mix(in srgb, var(--ion-color-primary) 8%, transparent);\r\n\r\n    ion-label {\r\n        color: var(--ion-color-primary) !important;\r\n        font-weight: 600 !important;\r\n    }\r\n}\r\n\r\n// List items (pilots, drones, batteries)\r\n.sub-menu-item {\r\n    --padding-start: 12px;\r\n    border-left: 5px solid var(--ion-color-primary);\r\n    border-radius: 8px;\r\n    color: black !important;\r\n    margin: 4px 10px 4px 10px;\r\n\r\n    .menu-chevron {\r\n        display: none !important;\r\n    }\r\n}\r\n\r\n.status-icon {\r\n  height: var(--icon-size-xx-small);\r\n  width: var(--icon-size-xx-small);\r\n}\r\n\r\n// Battery item specific styling\r\n.battery-item {\r\n    --min-height: 60px;\r\n    --max-height: 60px;\r\n}\r\n\r\n.battery-content {\r\n    display: flex;\r\n    width: 100%;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.battery-info {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    min-width: 0;\r\n}\r\n\r\n.battery-sn {\r\n    font-weight: 500;\r\n    color: black;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.battery-last-seen {\r\n    font-size: 0.75rem;\r\n    font-style: italic;\r\n    color: #666;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    margin-top: 2px;\r\n}\r\n\r\n.battery-icon-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-shrink: 0;\r\n}\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n/*#region Small Screens*/\r\n\r\n  /* Styles for screens smaller than 800px wide or 550 high */\r\n  @media (max-width: 800px) or (max-height: 550px) {\r\n\r\n    ion-item.menu-item {\r\n        --min-height: 40px;\r\n        --max-height: 40px;\r\n\r\n        .menu-label {\r\n            font-size: var(--font-size-small) !important;\r\n            font-weight: bold;\r\n        }\r\n\r\n        .menu-icon {\r\n            height: var(--icon-size-small);\r\n            width: var(--icon-size-small);\r\n        }\r\n    }\r\n\r\n    ion-item.sub-menu-item {\r\n        --min-height: 35px;\r\n        --max-height: 35px;\r\n        font-size: var(--font-size-small) !important;\r\n    }\r\n\r\n  }\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min with of 800px and min height of 550px */\r\n  @media (min-width: 800px) and (min-height: 550px) {\r\n\r\n    ion-item.menu-item {\r\n      --min-height: 50px;\r\n      --max-height: 50px;\r\n\r\n      .menu-label {\r\n          font-size: var(--font-size-small) !important;\r\n          font-weight: bold;\r\n      }\r\n\r\n      .menu-icon {\r\n          height: var(--icon-size-small);\r\n          width: var(--icon-size-small);\r\n      }\r\n    }\r\n\r\n    ion-item.sub-menu-item {\r\n        --min-height: 45px;\r\n        --max-height: 45px;\r\n        font-size: var(--font-size-small) !important;\r\n    }\r\n\r\n  }\r\n\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n\r\n  /* Styles for screens larger than 1000px wide and 600px high */\r\n  @media (min-width: 1000px) and (min-height: 600px) {\r\n\r\n    ion-item.menu-item {\r\n      --min-height: 55px;\r\n      --max-height: 55px;\r\n\r\n      .menu-label {\r\n          font-size: var(--font-size-small) !important;\r\n          font-weight: bold;\r\n      }\r\n\r\n      .menu-icon {\r\n          height: var(--icon-size-small);\r\n          width: var(--icon-size-small);\r\n      }\r\n    }\r\n\r\n    ion-item.sub-menu-item {\r\n        --min-height: 50px;\r\n        --max-height: 50px;\r\n        font-size: var(--font-size-small) !important;\r\n    }\r\n\r\n  }\r\n\r\n/*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
